import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import {
  TasksMethod,
  TasksDeleteTasksRequestData,
  TaskItem,
  TasksDeleteTasksResponseData,
  TasksRetryTasksResponseData,
  TasksRetryTasksRequestData,
} from '../types';

export class TasksBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'Tasks';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async retryRecords(records: Array<TaskItem>): Promise<TasksRetryTasksResponseData> {
    const payload: TasksRetryTasksRequestData = {
      records: records.map((item:TaskItem) => { const { _id, type, ownerId } = item; return { _id, type, ownerId }; }),
    };

    return ConsoleRequest.createRequest<TasksRetryTasksResponseData>({
      dataProviderType: this.dataProviderType,
      payload: payload,
      endpoint: this.endpoint,
      method: TasksMethod.RETRY_TASKS,
    });
  }

  public async removeRecords(records: Array<TaskItem>): Promise<TasksDeleteTasksResponseData> {
    const payload: TasksDeleteTasksRequestData = {
      records: records.map((item:TaskItem) => { const { _id, type } = item; return { _id, type }; }),
    };

    return ConsoleRequest.createRequest<TasksDeleteTasksResponseData>({
      dataProviderType: this.dataProviderType,
      payload: payload,
      endpoint: this.endpoint,
      method: TasksMethod.REMOVE_RECORDS,
    });

  }

  public async getDataForView() {
    return {};
  }
}
